export const MP_FN = 'Member of Parliament';
